import React from "react";
import styled from "@emotion/styled";
import { Typography, Grid } from "@mui/material";
import { Box } from "@mui/material";
import Slider from "react-slick";
import SimpleResponsivePicture from "./SimpleResponsivePicture";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export default function Testimonials({ Testimonial: testimonialData, ...props }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    // variableWidth: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: true,
    arrows: false,
    ...props?.options?.sliderOptions,
  };

  return (
    <>
      <Slider style={{ position: "relative" }} {...settings} style={{ minHeight: "110px" }}>
        {props?.Images?.data?.map((imageData, index) => {
          return <SimpleResponsivePicture imageObj={imageData.attributes} sx={{}} />;
        })}
      </Slider>
    </>
  );
}
